<svelte:options immutable={true} />

<script lang="ts">
  import Search from "./Search.svelte";
  import List from "./List.svelte";
  import { writable } from "svelte/store";
  import { SearchTree } from "../models/SearchTree";
  import { FormatTree } from "../models/FormatTree";
  import { TreeBuilder } from "../models/TreeBuilder";
  import { colors } from "../utils/colors.ts";

  export let params;
  export let oldInput;
  let div;
  let list;
  let searchField;
  let isShowTree = false;
  let formatManager = new FormatTree(params);
  let searchManager = new SearchTree(formatManager.getTree());
  let builder = new TreeBuilder();

  document.addEventListener("click", (e) => {
    for (const dEl of div.querySelectorAll("*")) {
      if (dEl === e.target) {
        return;
      }
    }
    isShowTree = false;
  });
  let query = "";
  let stree = writable(undefined);
  let targetId = writable(oldInput.value || null);
  let tree = { tree: {}, value: "" };
  stree.subscribe((tr) => {
    if (tr === undefined) {
      if (query < 4) {
        tree = builder.formatTree(formatManager.getTree());
      } else {
        tree = {};
      }

      return;
    }
    tree = tr;
    if (tr && tr.tree && isShowTree !== false) {
      const fl = isShowTree;
      isShowTree = null;
    } else {
      isShowTree = false;
    }
  });
</script>

<div
  bind:this={div}
  on:click={(e) => {
    isShowTree = true;
  }}
>
  <Search
    bind:builder
    bind:searchManager
    bind:searchField
    bind:formatManager
    bind:oldInput
    bind:query
    bind:params
    bind:tree
    onFocus={() => {}}
    bind:stree
    bind:targetId
  />
  <div
    style="--green: {isShowTree ? colors.green : 'transparent'}"
    class="wrap"
  >
    {#if isShowTree === true}
      <List
        bind:this={list}
        bind:searchField
        bind:query
        bind:isShowTree
        bind:tree
        bind:targetId
        {oldInput}
      />
    {:else if isShowTree === null}
      <List
        bind:this={list}
        bind:searchField
        bind:isShowTree
        bind:query
        bind:tree
        bind:targetId
        {oldInput}
      />
      {#if list && list.outerHTML}
        {@html list.outerHTML}
      {/if}
    {/if}
  </div>
</div>

<style>
  .wrap {
    max-height: 450px;
    position: absolute;
    overflow-y: auto;
    overflow-x: hidden;
    border: 1px solid var(--green);
    width: fit-content;
    z-index: 99999999;
  }
</style>
